import React, { useEffect, useState } from "react";
import { Form, Input, Button, Card, Typography, message } from "antd";
import axios from "axios";

const { Title } = Typography;

const FAQForm = ({ formData, setFormData, closeModal, refetchData }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (formData) {
      form.setFieldsValue(formData);
    }
  }, [formData]);

  const onFinish = async (values) => {
    try {
      if (formData?.id) {
        await axios.put(`http://93.127.203.113:5005/faqs/${formData.id}`, values);
        message.success("FAQ updated successfully.");
      } else {
        await axios.post("http://93.127.203.113:5005/faqs", values);
        message.success("FAQ added successfully.");
      }
      refetchData();
      closeModal();
    } catch (error) {
      message.error("Failed to save FAQ.");
    }
  };

  return (
    <Card style={{ padding: "20px", borderRadius: "10px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)" }}>
      <Title level={4} style={{ color: "#0c8c49", marginBottom: "20px" }}>
        {formData?.id ? "Edit FAQ" : "Add FAQ"}
      </Title>
      <Form form={form} onFinish={onFinish} layout="vertical">
        <Form.Item label="Question" name="question" rules={[{ required: true, message: "Please enter a question" }]}>
          <Input />
        </Form.Item>
        <Form.Item label="Answer" name="answer" rules={[{ required: true, message: "Please enter an answer" }]}>
          <Input.TextArea rows={3} />
        </Form.Item>
        <Button type="primary" htmlType="submit" style={{ backgroundColor: "#0c8c49", borderColor: "#0c8c49" }}>
          Save
        </Button>
      </Form>
    </Card>
  );
};

export default FAQForm;
